var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("CartController", [
    "$rootScope",
    "$scope",
    "$q",
    "configs",
    "$filter",
    "$sce",
    "$document",
    "$window",
    "$timeout",
    "cartService",
    "catalogService",
    "urlService",
    "shippingService",
    "membershipService",
    "membershipElasticService",
    "commonService",
    "cookiesFactory",
    "embrillianceElasticService",
    function (
        $rootScope,
        $scope,
        $q,
        configs,
        $filter,
        $sce,
        $document,
        $window,
        $timeout,
        cartService,
        catalogService,
        urlService,
        shippingService,
        membershipService,
        elasticService,
        commonService,
        cookiesFactory,
        embrillianceElasticService
    ) {
        var timer;
        $rootScope.showLoader = true;
        // #region Cart Scope Variables
        $scope.continueShoppingUrl = "/";
        $scope.shippingMethods = {
            showModal: false,
            cd: { usa: null, other: null },
            usb: { usa: null, other: null },
            formats: [],
            shippingMethodForm: null,
            shipACD: { format: null, shippingMethodName: "" },
        };
        $scope.isGiftcardSelected = false;
        $scope.selectedDest = "US";
        $scope.gotEstimate = false;
        $scope.selectedCountry;
        $scope.shippingErrors = false;
        $scope.applyCoupon = false;
        $scope.coupon = "";
        $scope.couponValid = null;
        $scope.selectedFormat = "";
        $scope.enableGuestCheckout = $window.__env.enableGuestCheckout;
        $scope.showGuestCheckout = false;
        $scope.txtEmail = "";
        $scope.txtConfirmEmail = "";
        $scope.validationMessage = "";
        $scope.isValidForm = true;
        $scope.regularExpressions =
            /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
        $scope.freeOrder = false;
        // #endregion

        //#region Initialize & Set Cart Form
        $scope.initialize = function () {
            getCart(true);
            $rootScope.$broadcast("CustomerCartChanged");
            var prevListingPageURL = cookiesFactory.get(
                "COMMERCE_SITE_PreviousCatalogPage"
            );
            $scope.continueShoppingUrl =
                prevListingPageURL == null || prevListingPageURL == "''"
                    ? "/"
                    : prevListingPageURL;
        };

        $scope.setCartForm = function (form) {
            $scope.formCart = form;
        };

        $scope.$watch(
            "cart.items",
            function (newVal, oldVal) {
                if (newVal) {
                    $scope.freeOrder = false;
                    if ($scope.cart) {
                        var totalListPrice = $scope.cart.items.reduce(function (
                            total,
                            item
                        ) {
                            return total + item.listPrice.amount;
                        },
                        0);
                        if (totalListPrice == 0) {
                            $scope.freeOrder = true;
                        }
                    }
                }
            },
            true
        ); // Deep watch if `items` is an array

        // #endregion

        function applyFilter(filterName, value) {
            return $filter(filterName)(value);
        }

        // #region Get Cart & Submit Cart
        function getCart(isInitialLoad) {
            $scope.isCouponApplied = localStorage.getItem("IsCouponApplied");
            $scope.couponCode = localStorage.getItem("AppliedCoupon");
            $scope.cartIsUpdating = true;
            if (
                $window.current_active_page !== "club_payment" ||
                $window.current_active_page === undefined
            ) {
                cartService
                    .moveListItemsToCart()
                    .then(function (response) {
                        return cartService.getCartForCheckout();
                    })
                    .then(function (response) {
                        var cart = response.data;
                        $scope.GetPromotions(cart);
                        cart.hasValidationErrors =
                            _.some(cart.validationErrors) ||
                            _.some(cart.items, function (item) {
                                return _.some(item.validationErrors);
                            });

                        $scope.cart = cart;
                        syncCouponStateFromCart(cart);
                        cartService
                            .getCartItemSchema()
                            .then(function (response) {
                                // #region Generate Cart Item Content
                                $scope.cart.items.forEach(function (item) {
                                    var html = "";
                                    angular.forEach(
                                        response.data,
                                        function (field) { 
                                            try {
                                                var label =
                                                    window.cartPageLocale[
                                                        field.label
                                                    ];

                                                var definition =
                                                    angular.isDefined(
                                                        field.definition
                                                    )
                                                        ? field.definition
                                                              .split(",")
                                                              .map(function (
                                                                  def
                                                              ) {
                                                                  return def
                                                                      .trim()
                                                                      .toLowerCase();
                                                              })
                                                        : [];

                                                var definitionExcludes =
                                                    angular.isDefined(
                                                        field.definitionExcludes
                                                    )
                                                        ? field.definitionExcludes
                                                              .split(",")
                                                              .map(function (
                                                                  def
                                                              ) {
                                                                  return def
                                                                      .trim()
                                                                      .toLowerCase();
                                                              })
                                                        : [];

                                                var includedInDefinition =
                                                    definition.length > 0 &&
                                                    definition.indexOf(
                                                        item.definitionName.toLowerCase()
                                                    ) !== -1;
                                                var excludedInDefinitionExcludes =
                                                    definitionExcludes.length >
                                                        0 &&
                                                    definitionExcludes.indexOf(
                                                        item.definitionName.toLowerCase()
                                                    ) == -1;

                                                if (
                                                    includedInDefinition ||
                                                    excludedInDefinitionExcludes
                                                ) {
                                                    var binding = field.binding
                                                        ? field.binding
                                                        : "";
                                                    var bindingText =
                                                        field.bindingText
                                                            ? field.bindingText
                                                            : "";
                                                    var value = "";

                                                    if (binding) {
                                                        try {
                                                            var width =
                                                                undefined;
                                                            var height =
                                                                undefined;

                                                            if (
                                                                binding.indexOf(
                                                                    "item.width"
                                                                ) > -1 &&
                                                                item.width > 0
                                                            ) {
                                                                width =
                                                                    applyFilter(
                                                                        "convertMMToInches",
                                                                        item.width
                                                                    );
                                                            }

                                                            if (
                                                                binding.indexOf(
                                                                    "item.height"
                                                                ) > -1 &&
                                                                item.height > 0
                                                            ) {
                                                                height =
                                                                    applyFilter(
                                                                        "convertMMToInches",
                                                                        item.height
                                                                    );
                                                            }

                                                            if (
                                                                binding.indexOf(
                                                                    "|"
                                                                ) > -1
                                                            ) {
                                                                var filters =
                                                                    binding.split(
                                                                        "|"
                                                                    );
                                                                if (
                                                                    filters &&
                                                                    filters.length >
                                                                        1
                                                                ) {
                                                                    for (
                                                                        var i =
                                                                            filters.length -
                                                                            1;
                                                                        i > 0;
                                                                        i--
                                                                    ) {
                                                                        value =
                                                                            applyFilter(
                                                                                filters[
                                                                                    i
                                                                                ].trim(),
                                                                                eval(
                                                                                    filters[0].trim()
                                                                                )
                                                                            );
                                                                    }
                                                                }
                                                                if (
                                                                    binding
                                                                        .toLowerCase()
                                                                        .indexOf(
                                                                            "fabriclength"
                                                                        ) >
                                                                        -1 &&
                                                                    value > 0
                                                                ) {
                                                                    value +=
                                                                        " yard";
                                                                }
                                                            }

                                                            if (
                                                                angular.isDefined(
                                                                    width
                                                                ) &&
                                                                angular.isDefined(
                                                                    height
                                                                )
                                                            ) {
                                                                value =
                                                                    width +
                                                                    '" W x ' +
                                                                    height +
                                                                    '" H';
                                                            } else if (
                                                                angular.isDefined(
                                                                    width
                                                                )
                                                            ) {
                                                                value =
                                                                    width +
                                                                    '" W';
                                                            } else if (
                                                                angular.isDefined(
                                                                    height
                                                                )
                                                            ) {
                                                                value =
                                                                    height +
                                                                    '" H';
                                                            } else if (
                                                                value === ""
                                                            ) {
                                                                value =
                                                                    eval(
                                                                        binding
                                                                    );
                                                            }
                                                        } catch (e) {
                                                            value = "";
                                                        }
                                                    }

                                                    if (bindingText) {
                                                        value =
                                                            window
                                                                .cartPageLocale[
                                                                bindingText
                                                            ];
                                                    }

                                                    if (
                                                        (angular.isUndefined(
                                                            field.case
                                                        ) ||
                                                            (angular.isDefined(
                                                                field.case
                                                            ) &&
                                                                field.case.toLowerCase() !==
                                                                    "neutral")) &&
                                                        angular.isDefined(value)
                                                    ) {
                                                        value = value
                                                            .toString()
                                                            .toUpperCase();
                                                    }

                                                    var labelLowerTrim = (
                                                        label + ""
                                                    )
                                                        .toLowerCase()
                                                        .trim();
                                                    var isPdSizeField =
                                                        item.definitionName.toLowerCase() ===
                                                            "personalizeddesign" &&
                                                        (labelLowerTrim ===
                                                            "custom size" ||
                                                            labelLowerTrim ===
                                                                "size") &&
                                                        item.cartLineItemCustomProperties &&
                                                        item
                                                            .cartLineItemCustomProperties
                                                            .length > 0;

                                                    if (
                                                        !isPdSizeField &&
                                                        (value.length > 1 ||
                                                            (!isNaN(
                                                                parseFloat(
                                                                    value
                                                                )
                                                            ) &&
                                                                parseFloat(
                                                                    value
                                                                ) > 0))
                                                    ) {
                                                        html +=
                                                            '<div class="flex">' +
                                                            '<span class="label">' +
                                                            label +
                                                            ": </span>" +
                                                            '<span class="cart-details" style="margin-left: 7.5px;" title="' +
                                                            value +
                                                            '">' +
                                                            value +
                                                            "</span></div>";
                                                    }

                                                     // Handle personalized design size
                                                     if (isPdSizeField) {
                                                        var pdProps =
                                                            item
                                                                .cartLineItemCustomProperties[0];
                                                        var sizeValue = "";
                                                        var sizeValueTitle =
                                                            "";

                                                        if (
                                                            pdProps.pdHoopSize !=
                                                                null &&
                                                            pdProps.pdHoopSize !==
                                                                ""
                                                        ) {
                                                            var pdAddText = (
                                                                pdProps.pdAddText ||
                                                                ""
                                                            ).trim();
                                                            if (pdAddText) {
                                                                label =
                                                                    "Text Added";
                                                                var escAdd = function (s) {
                                                                    return (s + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
                                                                };
                                                                sizeValue =
                                                                    escAdd(pdAddText);
                                                                sizeValueTitle =
                                                                    pdAddText;
                                                            } else {
                                                                label =
                                                                    "Text Replaced";
                                                                var r1 = (
                                                                    pdProps.pdReplaceText1 ||
                                                                    ""
                                                                ).trim();
                                                                var n1 = (
                                                                    pdProps.pdNewText1 ||
                                                                    ""
                                                                ).trim();
                                                                var r2 = (
                                                                    pdProps.pdReplaceText2 ||
                                                                    ""
                                                                ).trim();
                                                                var n2 = (
                                                                    pdProps.pdNewText2 ||
                                                                    ""
                                                                ).trim();
                                                                var esc = function (s) {
                                                                    return (s + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
                                                                };
                                                                var parts =
                                                                    [];
                                                                if (r1 && n1)
                                                                    parts.push(
                                                                        '1. "' +
                                                                            esc(r1) +
                                                                            '" → "' +
                                                                            esc(n1) +
                                                                            '"'
                                                                    );
                                                                if (r2 && n2)
                                                                    parts.push(
                                                                        '2. "' +
                                                                            esc(r2) +
                                                                            '" → "' +
                                                                            esc(n2) +
                                                                            '"'
                                                                    );
                                                                sizeValue =
                                                                    parts.join(
                                                                        "<br/>"
                                                                    );
                                                                sizeValueTitle =
                                                                    parts.join(" ");
                                                            }
                                                        } else {
                                                            if (
                                                                pdProps.pdIsCap ===
                                                                true
                                                            ) {
                                                                var capText =
                                                                    '<span class="desktop-text responsive-text">Optimized For Cap</span><span class="mobile-text responsive-text">Cap Size</span>';
                                                                sizeValue =
                                                                    capText;
                                                                sizeValueTitle =
                                                                    "Optimized For Cap";
                                                            } else if (
                                                                pdProps.pdIsProportionalHeight ===
                                                                true
                                                            ) {
                                                                var pdWidth =
                                                                    parseFloat(
                                                                        pdProps.pdWidth
                                                                    ) || 0;
                                                                if (
                                                                    pdWidth > 0
                                                                ) {
                                                                    var optimizedHText =
                                                                        '<span class="desktop-text responsive-text">Optimized H</span><span class="mobile-text responsive-text">Opt. H</span>';
                                                                    sizeValue =
                                                                        pdWidth +
                                                                        '" W x ' +
                                                                        optimizedHText;
                                                                    sizeValueTitle =
                                                                        pdWidth +
                                                                        '" W x Optimized H';
                                                                }
                                                            } else if (
                                                                pdProps.pdIsProportionalWidth ===
                                                                true
                                                            ) {
                                                                var pdHeight =
                                                                    parseFloat(
                                                                        pdProps.pdHeight
                                                                    ) || 0;
                                                                if (
                                                                    pdHeight > 0
                                                                ) {
                                                                    var optimizedHText2 =
                                                                        '<span class="desktop-text responsive-text">Optimized W</span><span class="mobile-text responsive-text">Opt. W</span>';
                                                                    sizeValue =
                                                                        pdHeight +
                                                                        '" H x ' +
                                                                        optimizedHText2;
                                                                    sizeValueTitle =
                                                                        pdHeight +
                                                                        '" H x Optimized W';
                                                                }
                                                            } else {
                                                                var pdWidth2 =
                                                                    parseFloat(
                                                                        pdProps.pdWidth
                                                                    ) || 0;
                                                                var pdHeight2 =
                                                                    parseFloat(
                                                                        pdProps.pdHeight
                                                                    ) || 0;
                                                                if (
                                                                    pdWidth2 >
                                                                        0 &&
                                                                    pdHeight2 > 0
                                                                ) {
                                                                    sizeValue =
                                                                        pdWidth2 +
                                                                        '" W x ' +
                                                                        pdHeight2 +
                                                                        '" H';
                                                                    sizeValueTitle =
                                                                        sizeValue;
                                                                } else if (
                                                                    (!pdWidth2 ||
                                                                        pdWidth2 <=
                                                                            0) &&
                                                                    pdHeight2 > 0
                                                                ) {
                                                                    sizeValue =
                                                                        pdHeight2 +
                                                                        '" H';
                                                                    sizeValueTitle =
                                                                        sizeValue;
                                                                } else if (
                                                                    pdWidth2 >
                                                                        0 &&
                                                                    (!pdHeight2 ||
                                                                        pdHeight2 <=
                                                                            0)
                                                                ) {
                                                                    sizeValue =
                                                                        pdWidth2 +
                                                                        '" W';
                                                                    sizeValueTitle =
                                                                        sizeValue;
                                                                }
                                                            }

                                                            var resizeLabelPlain = (
                                                                sizeValueTitle ||
                                                                ""
                                                            ).toLowerCase();
                                                            label =
                                                                resizeLabelPlain.indexOf(
                                                                    "optimized"
                                                                ) !== -1
                                                                    ? '<span class="desktop-text">Size</span><span class="mobile-text">Size</span>'
                                                                    : '<span class="desktop-text">Custom Size</span><span class="mobile-text">Size</span>';
                                                        }

                                                        if (sizeValue) {
                                                            var titleValue =
                                                                sizeValueTitle ||
                                                                sizeValue;
                                                            var isLettering =
                                                                pdProps.pdHoopSize != null &&
                                                                pdProps.pdHoopSize !== "";
                                                            var safeTitle = (
                                                                titleValue + ""
                                                            ).replace(/'/g, "&#39;");
                                                            if (isLettering) {
                                                                html +=
                                                                    '<div class="flex"><span class="label">' +
                                                                    label +
                                                                    ":</span></div>" +
                                                                    '<div class="flex flex-wrap"><span class="det det-pd-value" title="' +
                                                                    safeTitle +
                                                                    '">' +
                                                                    sizeValue +
                                                                    "</span></div>";
                                                            } else {
                                                                html +=
                                                                    '<div class="flex">' +
                                                                    '<span class="label">' +
                                                                    label +
                                                                    ":</span>" +
                                                                    '<span class="det" title="' +
                                                                    safeTitle +
                                                                    '">' +
                                                                    sizeValue +
                                                                    "</span></div>";
                                                            }
                                                        }
                                                    }
                                                    
                                                }
                                                 
                                            } catch (err) {}
                                        }
                                    );
                                    item.generatedHtml = $sce.trustAsHtml(html);
                                });
                            });

                        $rootScope.showLoader = false;
                        $scope.showUnavailablelbl = false;
                        getProductsInventory();
                        if ($scope.cartHasEmbrillianceProduct()) {
                            loadEmbrillianceCartRecommendations();
                        }
                        $scope.subTotal =
                            cart.subTotal.amount -
                            cart.discountTotal.amount;
                        $scope.getBuyXPercentOffNudges();
                        $scope.cartIsUpdating = false;
                        $scope.noOfFreeDesignsExceeding =
                            cart.freeDesignsUserCanOrder;
                        $scope.isAllChecked = false;
                        $scope.noOfitemslimit = cart.cartItemLimit
                            .toString()
                            .replace("-", "");

                        if (
                            angular.isDefined(cart.customer) &&
                            angular.isDefined(cart.customer.userGroups)
                        ) {
                            $scope.isAnnsClubMember =
                                cart.customer.userGroups.some(function (elm) {
                                    if (elm.toLowerCase() == "clubmember") {
                                        return true;
                                    }
                                });
                        }
                        if (!$scope.isAnnsClubMember && cart.items.length > 0) {
                            getClubPriceTotal();
                        }

                        $rootScope.$emit("RefreshCurrencyConversion");
                        if (
                            typeof gtag !== "undefined" &&
                            gtag !== null &&
                            cart != null &&
                            isInitialLoad
                        ) {
                            var cartObj = {
                                currency: "USD",
                                affiliation: "AnnTheGran.com",
                                value: cart.subTotal.amount,
                                items: cart.items.map(function (item) {
                                    return {
                                        item_name: item.name,
                                        item_id: item.sku,
                                        price: item.placedPrice.amount,
                                        item_category: item.definitionName,
                                        quantity: item.quantity,
                                    };
                                }),
                            };
                            gtag("event", "view_cart", cartObj);
                        }
                    })
                    .catch(function (error) {
                        $scope.cartIsUpdating = false;
                    });
            }
        }

        $scope.submitCart = function () {
            $scope.formCart.$setSubmitted();
            if ($scope.formCart.$invalid) {
                return;
            }
            cartService
                .updateCartComment($scope.cart.comment)
                .then(function (resp) {
                    $scope.outerRedirect($scope.baseUrl + "cart/checkout");
                });
        };

        $scope.CheckoutCart = function () {
            if (
                $rootScope.currencyConversion.displayCurrency &&
                $rootScope.currencyConversion.localCurrency &&
                $rootScope.currencyConversion.displayCurrency ==
                    $rootScope.currencyConversion.localCurrency
            ) {
                $rootScope.appModalOpen = true;
                $rootScope.currencyConversion.showModal = true;
                $rootScope.currencyConversion.redirectUrl =
                    $scope.cartHasPhysicalProduct() ||
                    $scope.shippingMethods.shipACD.shippingMethodName != ""
                        ? "/cart/checkout/shipping"
                        : "/cart/checkout";
            } else if (
                $scope.cartHasPhysicalProduct() ||
                $scope.shippingMethods.shipACD.shippingMethodName != ""
            ) {
                $window.location.href = "/cart/checkout/shipping";
            } else {
                $window.location.href = "/cart/checkout";
            }
        };
        // #endregion

        // #region Edit Cart
        $scope.changeLineItemQuantity = function (lineItemId, quantity) {
            var lineItem = _.find($scope.cart.items, function (i) {
                return i.id == lineItemId;
            });
            if (
                !lineItem ||
                quantity < 1 ||
                $scope.cartIsUpdating ||
                $scope.formCart.$invalid
            ) {
                return;
            }
            var initialQuantity = lineItem.quantity;
            lineItem.quantity = quantity;
            $timeout.cancel(timer);
            timer = $timeout(function () {
                $scope.cartIsUpdating = true;
                cartService.changeLineItemQuantity(lineItemId, quantity).then(
                    function (response) {
                        getCart();
                        $rootScope.$broadcast("CustomerCartChanged");
                    },
                    function (response) {
                        lineItem.quantity = initialQuantity;
                        $scope.cartIsUpdating = false;
                    }
                );
            }, 300);
        };

        $scope.changeLineItemPrice = function (lineItemId, newPrice) {
            var lineItem = $scope.cart.items.find(function (i) {
                return i.id == lineItemId;
            });
            if (!lineItem || $scope.cartIsUpdating) {
                return;
            }
            $scope.cartIsUpdating = true;
            cartService.changeLineItemPrice(lineItemId, newPrice).then(
                function (response) {
                    getCart();
                    $rootScope.$broadcast("CustomerCartChanged");
                },
                function () {
                    $scope.cart.items = initialItems;
                    $scope.cartIsUpdating = false;
                }
            );
        };

        $scope.removeLineItem = function (lineItemId) {
            $rootScope.showLoader = true;
            var lineItem = _.find($scope.cart.items, function (i) {
                return i.id == lineItemId;
            });
            if (!lineItem || $scope.cartIsUpdating) {
                return;
            }
            var initialItems = angular.copy($scope.cart.items);
            $scope.cart.items = $scope.cart.items.filter(function (item) {
                return item.id != lineItemId;
            });
            cartService.removeLineItem(lineItemId).then(
                function (response) {
                    getCart();
                    $scope.toggleCouponSection(false);
                    $scope.removeCoupon();
                    $rootScope.$broadcast("CustomerCartChanged");

                    //GA 4
                    if (
                        typeof gtag !== "undefined" &&
                        gtag !== null &&
                        $scope.cart.items != null &&
                        $scope.cart.items.length > 0 &&
                        lineItem != null
                    ) {
                        cartObj = {
                            currency: "USD",
                            affiliation: "AnnTheGran.com",
                            price: lineItem.salePrice.amount,
                            items: [
                                {
                                    item_name: lineItem.name,
                                    item_id: lineItem.sku,
                                    item_category: lineItem.definitionName,
                                    quantity: lineItem.quantity,
                                },
                            ],
                        };
                        gtag("event", "remove_from_cart", cartObj);
                    }
                    //End Region
                },
                function (response) {
                    $scope.cart.items = initialItems;
                    $rootScope.showLoader = false;
                    $scope.cartIsUpdating = false;
                }
            );
        };

        $scope.removeGiftCardLineItem = function (lineItemId) {
            var lineItem = _.find($scope.cart.items, function (i) {
                return i.id == lineItemId;
            });
            if (!lineItem || $scope.cartIsUpdating) {
                return;
            }
            $scope.cartIsUpdating = true;
            var initialItems = angular.copy($scope.cart.items);
            $scope.cart.items = $scope.cart.items.filter(function (item) {
                return item.id != lineItemId;
            });
            cartService.removeGiftCardLineItem(lineItemId).then(
                function (response) {
                    getCart();
                    $rootScope.$broadcast("CustomerCartChanged");
                },
                function (response) {
                    $scope.cart.items = initialItems;
                    $scope.cartIsUpdating = false;
                }
            );
        };

        $scope.addProductToCart = function (product, quantity) {
            $scope.cartIsUpdating = true;
            cartService
                .addLineItem(product.id, quantity)
                .then(function (response) {
                    if (response && response.data && response.data.itemAdded) {
                        getCart();
                        $scope.productSkuOrName = null;
                        $scope.selectedSearchedProduct = null;
                    } else {
                        alert(
                            "Cart has reached Max Limit. Please checkout before adding any more new item's."
                        );
                    }
                    $rootScope.$broadcast("CustomerCartChanged");
                });
        };

        function deleteBulkItemsFromCart(selectedItems) {
            if (
                confirm("Are you sure you want to Delete all selected item(s)?")
            ) {
                $rootScope.showLoader = true;
                var selectedItemIds = selectedItems.map(function (item) {
                    return item.id;
                });
                var initialItems = angular.copy($scope.cart.items);
                cartService.removeLineItems(selectedItemIds).then(
                    function (response) {
                        getCart();
                        $rootScope.$broadcast("CustomerCartChanged");
                    },
                    function (response) {
                        $scope.cart.items = initialItems;
                        $rootScope.showLoader = false;
                        $scope.cartIsUpdating = false;
                    }
                );
            }
            $scope.selectedAction = "";
        }
        // #endregion

        // #region Search Cart
        $scope.searchProduct = function () {
            $scope.productSearchResult = null;
            if ($scope.productSkuOrName) {
                $timeout.cancel(timer);
                timer = $timeout(function () {
                    $scope.productSearchProcessing = true;
                    var criteria = {
                        keyword: $scope.productSkuOrName,
                        start: 0,
                        pageSize: 5,
                    };
                    catalogService.search(criteria).then(
                        function (response) {
                            $scope.productSearchProcessing = false;
                            $scope.productSearchResult = response.data.products;
                        },
                        function (response) {
                            $scope.productSearchProcessing = false;
                        }
                    );
                }, 300);
            }
        };

        $scope.selectSearchedProduct = function (product) {
            $scope.productSearchResult = null;
            $scope.selectedSearchedProduct = product;
            $scope.productSkuOrName = product.name;
        };

        // #endregion

        //  #region Promotions & Discounts
        $scope.GetPromotions = function (cart) {
            $scope.appliedDiscounts = [];
            if (cart.items.length > 0) {
                // For item level promotions
                cart.items.forEach(function (cartItem) {
                    if (cartItem.discounts.length > 0) {
                        cartItem.discounts.forEach(function (discount) {
                            if (
                                discount.description &&
                                discount.description.toLowerCase() ==
                                    "club membership"
                            ) {
                                discount.amount.amount = discount.amount.amount;
                            } else {
                                discount.amount.amount =
                                    discount.amount.amount *
                                    (angular.isNumber(cartItem.quantity)
                                        ? cartItem.quantity
                                        : 1);
                            }
                            $scope.appliedDiscounts.push(discount);
                        });
                    }
                });

                $scope.promotions = [];
                $scope.appliedDiscounts.forEach(function (discount) {
                    var index = -1;
                    for (var i = 0; i < $scope.promotions.length; i++) {
                        if (
                            $scope.promotions[i].promotionId ==
                            discount.promotionId
                        ) {
                            index = i;
                            break;
                        }
                    }
                    if (index < 0) {
                        $scope.promotions.push(discount);
                    } else {
                        $scope.promotions[index].amount.amount +=
                            discount.amount.amount;
                    }
                });

                // For cart level sales & promotions
                cart.discounts.forEach(function (discount) {
                    if (discount.amount.amount > 0) {
                        $scope.promotions.push(discount);
                    }
                });
            }
        };
        // #endregion

        // #region Products Related
        function getPhysicalProducts(data) {
            return data.filter(function (elm) {
                return elm.productType.toLowerCase() == "physical";
            });
        }

        function getGiftCertificate(data) {
            return data.filter(function (elm) {
                return elm.catalogId.toLowerCase() == "gift certificates";
            });
        }

        function checkProductsAvailability(prdInfo, inventoryInfo) {
            angular.forEach(prdInfo, function (prd) {
                if (prd.productType.toLowerCase() == "physical") {
                    var result = inventoryInfo.find(function (p) {
                        return (
                            p.productId.toLowerCase() ==
                            prd.productId.toLowerCase()
                        );
                    });
                    if (result) {
                        prd.availableQuantity =
                            result.status !== 0 ? result.inStockQuantity : 0;
                    }
                    if (prd.quantity > prd.availableQuantity) {
                        $scope.showUnavailablelbl = true;
                    }
                }
            });
        }

        function getProductsInventory() {
            if (
                angular.isDefined($scope.cart) &&
                angular.isDefined($scope.cart.items) &&
                $scope.cart.items.length > 0
            ) {
                var physicalProducts = getPhysicalProducts($scope.cart.items);
                if (
                    angular.isDefined(physicalProducts) &&
                    physicalProducts.length > 0
                ) {
                    var prdIds = physicalProducts.map(function (prd) {
                        return prd.productId;
                    });
                    commonService
                        .getProductsInventory(prdIds)
                        .then(function (response) {
                            if (response && response.data) {
                                checkProductsAvailability(
                                    $scope.cart.items,
                                    response.data
                                );
                            }
                        });
                }
            }
        }

        $scope.cartHasPhysicalProduct = function () {
            return $scope.cart.items.some(function (item) {
                return item.productType.toLowerCase() == "physical";
            });
        };

        $scope.isCartHasOnlyGC = function () {
            var giftCertificate = getGiftCertificate($scope.cart.items);
            return giftCertificate.length == $scope.cart.items.length;
        };

        $scope.getPrdImageUrl = function (item) {
            if (
                item.definitionName.toLowerCase() == "thread" &&
                item.displayImageSwatch
            )
                item.size = "large";


                item.pdLineItems = [];
                item.pdLineItems.push(item.cartLineItemCustomProperties[0]);
            return urlService.getItemImageUrl(item);
        };

        $scope.getPrdUrl = function (item, cart) {
            return urlService.getItemUrl(item, cart);
        };

        $scope.onQtyChange = function (item) {
            item.showQtyInput = item.tempQuantity == 0;
        };

        $scope.getItemPrice = function (item) {
            if (item.productType.toLowerCase() == "physical") {
                return item.placedPrice.amount * item.quantity;
            } else {
                return item.placedPrice.amount;
            }
        };

        $scope.getItemDiscount = function (item) {
            if (item.discounts.length > 0) {
                return item.discountTotal.internalAmount || 0;
            }
            return 0;
        };

        $scope.buyXPercentOffNudgesByLineItemId = {};

        $scope.getBuyXPercentOffNudges = function () {
            if (
                !$scope.cart ||
                !$scope.cart.items ||
                $scope.cart.items.length === 0
            ) {
                $scope.buyXPercentOffNudgesByLineItemId = {};
                return;
            }

            var cartItems = $scope.cart.items.map(function (item) {
                return {
                    lineItemId: item.id,
                    productId: item.productId,
                    extendedListPrice:
                        item.extendedListPrice &&
                        item.extendedListPrice.amount != null
                            ? item.extendedListPrice.amount
                            : 0,
                    quantity: item.quantity,
                };
            });

            cartService.getBuyXPercentOffNudges(cartItems).then(function (response) {
                var nudgesByLineItemId = {};
                if (response && response.data && response.data.length > 0) {
                    response.data.forEach(function (nudge) {
                        if (nudge && nudge.lineItemId) {
                            nudgesByLineItemId[nudge.lineItemId] = nudge;
                        }
                    });
                }
                $scope.buyXPercentOffNudgesByLineItemId = nudgesByLineItemId;
            });
        };

        $scope.getBuyXPercentOffNudge = function (item) {
            if (
                !item ||
                !$scope.buyXPercentOffNudgesByLineItemId ||
                !$scope.buyXPercentOffNudgesByLineItemId[item.id]
            ) {
                return null;
            }
            return $scope.buyXPercentOffNudgesByLineItemId[item.id];
        };

        $scope.getBuyXPercentOffNudgeSaleUrl = function (nudge) {
            if (!nudge || !nudge.saleUrl) {
                return "";
            }
            var saleUrl = (nudge.saleUrl + "").trim();
            if (/^https?:\/\//i.test(saleUrl)) {
                return saleUrl;
            }
            var base = (
                ($scope.baseUrl || $rootScope.baseUrl || "") + ""
            ).replace(/\/+$/, "");
            if (!base) {
                return saleUrl.charAt(0) === "/" ? saleUrl : "/" + saleUrl;
            }
            return (
                base +
                (saleUrl.charAt(0) === "/" ? saleUrl : "/" + saleUrl)
            );
        };
        // #endregion

        // #region Cart Actions
        $scope.getNumber = function (num) {
            return new Array(num);
        };

        $scope.onQtyUpdate = function (item) {
            if (item.showQtyUpdate) {
                if (item.showQtyInput) {
                    if (
                        angular.isDefined(item.inputQty) &&
                        Number(item.inputQty) > 9 &&
                        Number(item.inputQty < 100)
                    ) {
                        if (item.inputQty > item.availableQuantity) {
                            $scope.showUnavailablelbl = true;
                            item.showAvailableQty = true;
                        } else {
                            item.showQtyUpdate = false;
                            item.quantity = item.inputQty;
                            $rootScope.showLoader = true;
                            updateQuantity(item);
                        }
                    } else {
                        item.quantity = 1;
                        item.showQtyUpdate = true;
                        alert(
                            "Quantity entered should be in range of 10 to 99"
                        );
                    }
                } else {
                    if (item.tempQuantity > item.availableQuantity) {
                        $scope.showUnavailablelbl = true;
                        item.showAvailableQty = true;
                    } else {
                        item.quantity = item.tempQuantity;
                        item.showQtyUpdate = false;
                        $rootScope.showLoader = true;
                        updateQuantity(item);
                    }
                }
            } else {
                if (angular.isDefined(item.showQtyInput) && item.showQtyInput) {
                    if (
                        angular.isDefined(item.inputQty) &&
                        Number(item.inputQty) > 9 &&
                        Number(item.inputQty < 100)
                    ) {
                        item.quantity = item.inputQty;
                        item.showQtyUpdate = true;
                    } else {
                        item.quantity = 1;
                        item.showQtyUpdate = false;
                        alert(
                            "Quantity entered should be in range of 10 to 99"
                        );
                    }
                } else {
                    if (
                        angular.isDefined(item.tempQuantity) &&
                        item.tempQuantity > 0
                    ) {
                        item.quantity = item.tempQuantity;
                        item.showQtyUpdate = true;
                    } else {
                        item.quantity = 1;
                        item.showQtyUpdate = true;
                    }
                }
            }
        };

        $scope.isGiftcard = function (defName) {
            return defName.toLowerCase() == "giftcertificate";
        };

        $scope.checkUncheckAll = function (isAllChecked) {
            angular.forEach($scope.cart.items, function (item) {
                if ($scope.isGiftcard(item.definitionName)) {
                    $scope.isGiftcardSelected = isAllChecked;
                }
                item.isSelected = isAllChecked;
            });
        };

        $scope.onCheckboxClick = function (item) {
            if (angular.isDefined($scope.cart.items)) {
                var cartItems = $scope.cart.items;
                if (item.isSelected) {
                    if ($scope.isGiftcard(item.definitionName)) {
                        $scope.isGiftcardSelected = true;
                    }
                    for (var i = 0; i < cartItems.length; i++) {
                        $scope.isAllChecked = true;
                        if (!cartItems[i].isSelected) {
                            $scope.isAllChecked = false;
                            break;
                        }
                    }
                } else {
                    if ($scope.isGiftcard(item.definitionName)) {
                        $scope.isGiftcardSelected = false;
                    }
                    for (var i = 0; i < cartItems.length; i++) {
                        $scope.isAllChecked = false;
                    }
                }
            }
        };

        function filterAllSelectedItems() {
            var selectedItems = [];
            angular.forEach($scope.cart.items, function (item) {
                if (item.isSelected) {
                    selectedItems.push(item);
                }
            });
            return selectedItems;
        }

        function updateQuantity(item) {
            cartService
                .changeLineItemQuantity(item.id, item.quantity)
                .then(function (response) {
                    if (response && response.data) {
                        $rootScope.showLoader = false;
                        $window.location.reload();
                    } else {
                        alert(
                            "Cart has reached Max Limit. Please checkout before adding any more new item's."
                        );
                    }
                });
        }

        $scope.onActionChange = function (selectedAction) {
            var selectedItems = filterAllSelectedItems();
            $scope.selectedAction = "";
            if (selectedItems.length > 0) {
                switch (selectedAction) {
                    case "Delete":
                        deleteBulkItemsFromCart(selectedItems);
                        break;
                    case "MoveToList":
                        updateItemsFavoritesGroup(selectedItems);
                        break;
                    default:
                        break;
                }
                $scope.isAllChecked = false;
                $scope.checkUncheckAll(false);
            } else {
                alert("please select atleast one item to proceed..");
                $scope.selectedAction = "";
            }
        };

        $scope.onShowDiscountsClick = function (item) {
            item.showDiscountsContent = !item.showDiscountsContent;
        };
        // #endregion

        // #region Favorites
        $scope.toggleNewFavoritesGroupModal = function (status, sku) {
            if (angular.isDefined(sku)) {
                $rootScope.newFavoritesSKU = sku;
            }
            var modal = $document[0].getElementById("favorites-group");
            if (modal) {
                modal.classList.toggle("hide", !status);
            }
        };

        function updateItemsFavoritesGroup(selectedItems) {
            if (
                confirm("Are you sure you want to move all selected item(s)?")
            ) {
                $rootScope.selectedItems = [];
                angular.forEach(selectedItems, function (item) {
                    $rootScope.selectedItems.push(item.productId);
                });
                if (angular.isDefined($rootScope.selectedItems)) {
                    $rootScope.newFavoritesSKU =
                        $rootScope.selectedItems.join(",");
                }
                $scope.toggleNewFavoritesGroupModal(true);
                $scope.selectedAction = "";
            }
        }
        // #endregion

        // #region Club Membership
        $scope.isTenurePromotionActive = false;
        if (
            $window.__env &&
            $window.__env.IsTenurePromotionActive &&
            $window.__env.TenurePromotionCreditMonths
        ) {
            var tenurePromoMonths = $window.__env.TenurePromotionCreditMonths;
            $scope.isTenurePromotionActive = true;
            $scope.tenurePromoLabel =
                "+" +
                tenurePromoMonths +
                " free month" +
                (tenurePromoMonths > 1 ? "s" : "") +
                " bonus";
        }
        $scope.showTenurePromoForPlan = function (plan) {
            if (!$scope.isTenurePromotionActive || !plan) {
                return false;
            }
            var tenure = parseInt(plan.planTenure, 10);
            return tenure === 12 || tenure === 24;
        };

        function getClubPriceTotal() {
            function getClubPrice(listPrice, salePrice, clubPrice) {
                listPrice = listPrice != undefined ? Number(listPrice) : null;
                salePrice = salePrice != undefined ? Number(salePrice) : null;
                clubPrice = clubPrice != undefined ? Number(clubPrice) : null;
                if (salePrice != null) {
                    if (clubPrice != null) {
                        if (salePrice < clubPrice) return salePrice;
                        else return clubPrice >= 0 ? clubPrice : salePrice;
                    } else return salePrice;
                } else if (clubPrice != null)
                    return clubPrice >= 0 ? clubPrice : listPrice;
                else return listPrice;
            }
            function getItemQuantity(itemId) {
                var quantity = 1;

                var filteredResults = $scope.cart.items.filter(function (item) {
                    return item.productId.toLowerCase() == itemId.toLowerCase();
                });

                quantity = filteredResults
                    .map(function (c) {
                        return c.quantity;
                    })
                    .reduce(function (a, b) {
                        return a + b;
                    });

                return quantity;
            }
            var productIds = [];
            var idsToRemove = [];
            if (configs && configs.giftCardProductIds) {
                idsToRemove = configs.giftCardProductIds;
            }
            if (configs && configs.customDigitizingProductIds) {
                idsToRemove = idsToRemove.concat(
                    configs.customDigitizingProductIds
                );
            }
            clubPriceTotal = 0;
            $scope.cart.items.forEach(function (item) {
                // checking for Giftcards and Custom Digitizing items
                if (idsToRemove.indexOf(item.productId.toLowerCase()) > -1) {
                    clubPriceTotal = clubPriceTotal + item.salePrice.amount;
                }
                //adding other Ids
                else {
                    productIds.push(item.productId);
                }
            });
            if (productIds && productIds.length > 0) {
                // Removing variantid from SKU for elastic query
                var strProductIds = productIds
                    .map(function (id) {
                        return id.split(/_var_/gi)[0];
                    })
                    .join('","');
                commonService
                    .getElasticData(
                        configs.elasticBaseUrl,
                        elasticService.buildClubPricesTotalRequest(
                            strProductIds
                        )
                    )
                    .then(function (response) {
                        if (response.data) {
                            var items =
                                response.data.aggregations.items.hits.hits;
                            if (items && items.length > 0) {
                                productIds.forEach(function (id) {
                                    variantId = undefined;
                                    if (
                                        id.toLowerCase().indexOf("_var_") > -1
                                    ) {
                                        variantId = id.split(/_var_/gi)[1];
                                        itemId = id.split(/_var_/gi)[0];
                                    } else {
                                        itemId = id;
                                    }
                                    item = items.filter(function (i) {
                                        return i._id.toLowerCase() == itemId;
                                    });
                                    if (item && item.length > 0) {
                                        item = item[0]._source;
                                        if (variantId) {
                                            item = item.variants.filter(
                                                function (v) {
                                                    return (
                                                        v.variantId == variantId
                                                    );
                                                }
                                            )[0];
                                        }
                                        var clubPrice = getClubPrice(
                                            item.listPrice,
                                            item.salePrice,
                                            item.clubPrice
                                        );
                                        clubPriceTotal =
                                            clubPriceTotal +
                                            getItemQuantity(id) * clubPrice;
                                        $scope.clubPriceTotal = clubPriceTotal;
                                    }
                                });
                            }
                        }
                        //($scope.cart.discountTotal.amount - $scope.cart.discountAmount.amount) -> to calculate cart level discounts
                        $scope.membershipSavings =
                            $scope.cart.subTotal.amount -
                            ($scope.cart.discountTotal.amount -
                                $scope.cart.discountAmount.amount) -
                            $scope.clubPriceTotal;
                    });
            } else {
                $scope.clubPriceTotal = undefined;
                $scope.membershipSavings = undefined;
            }
        }

        $scope.getMembershipPlans = function () {
            membershipService.getMembershipPlans().then(function (response) {
                if (response && response.data) {
                    $rootScope.membershipPlans = response.data;
                    $scope.selectedPlan =
                        response.data[0].planTenure.toString();
                }
            });
        };

        $scope.onMembershipModalInit = function () {
            if (
                $scope.showMembershipModal &&
                ($rootScope.isMembershipInfoAvailable == false ||
                    angular.isUndefined($rootScope.isMembershipInfoAvailable))
            ) {
                $scope.getMembershipPlans();
                $scope.getPageContent();
                $rootScope.isMembershipInfoAvailable = true;
            }
        };

        $scope.onMembershipCheckout = function (selectedPlan) {
            if (selectedPlan) {
                var planToCheckout = $rootScope.membershipPlans.filter(
                    function (plan) {
                        return plan.planTenure == selectedPlan;
                    }
                );
                if (angular.isDefined(planToCheckout)) {
                    $rootScope.showLoader = true;
                    cartService
                        .addMembershipCart(
                            planToCheckout[0].planId,
                            planToCheckout[0].planTenure
                        )
                        .then(function (response) {
                            if (response && response.data) {
                                $rootScope.showLoader = false;
                                $window.location.href = "cart/checkout";
                            } else {
                                $rootScope.showLoader = false;
                                $window.location.href =
                                    "/account/login?ReturnUrl=/annsclub";
                            }
                        });
                } else {
                    alert("Please select a valid Plan");
                }
            } else {
                alert("Please select a valid Plan");
            }
        };

        $rootScope.toggleModal = function (ModalId, state) {
            $rootScope[ModalId] = state;
        };
        // #endregion

        //#region Shipping Methods

        getShippingFormats = function () {
            shippingService.getShippingFormats().then(function (response) {
                $scope.shippingMethods.formats = response.data || [];
            });
        };

        getShipACDRates = function () {
            shippingService.getShipACDRates().then(function (response) {
                if (response && response.data) {
                    var cdUSA = response.data.filter(function (item) {
                        return (
                            item.shippingMethodName.toLowerCase() ==
                            "standard shipping (cd)"
                        );
                    });
                    $scope.shippingMethods.cd.usa =
                        cdUSA &&
                        cdUSA.length > 0 &&
                        cdUSA[0].price.formattedAmount;

                    var cdOther = response.data.filter(function (item) {
                        return (
                            item.shippingMethodName.toLowerCase() ==
                            "standard shipping (cd - international)"
                        );
                    });
                    $scope.shippingMethods.cd.other =
                        cdOther &&
                        cdOther.length > 0 &&
                        cdOther[0].price.formattedAmount;

                    var usbUSA = response.data.filter(function (item) {
                        return (
                            item.shippingMethodName.toLowerCase() ==
                            "standard shipping (usb)"
                        );
                    });
                    $scope.shippingMethods.usb.usa =
                        usbUSA &&
                        usbUSA.length > 0 &&
                        usbUSA[0].price.formattedAmount;

                    var usbOther = response.data.filter(function (item) {
                        return (
                            item.shippingMethodName.toLowerCase() ==
                            "standard shipping (usb - international)"
                        );
                    });
                    $scope.shippingMethods.usb.other =
                        usbOther &&
                        usbOther.length > 0 &&
                        usbOther[0].price.formattedAmount;
                }
            });
        };

        $scope.onShippingModalInit = function () {
            if (
                $scope.shippingMethods.showModal &&
                ($rootScope.isShippingInfoAvailable == false ||
                    angular.isUndefined($rootScope.isShippingInfoAvailable))
            ) {
                getShipACDRates();
                getShippingFormats();
                $rootScope.isShippingInfoAvailable = true;
            }
        };

        $scope.updateShippingMethod = function () {
            if ($scope.shippingMethods.shipACD.shippingMethodName) {
                shippingService
                    .updateShippingMethod($scope.shippingMethods.shipACD)
                    .then(function () {
                        $scope.CheckoutCart();
                    });
            } else {
                $scope.CheckoutCart();
            }
        };

        $scope.showEstimateShipping = function () {
            $scope.isUSShipping = true;
            $scope.gotEstimate = false;
            $scope.shippingErrors = false;
            $scope.shippingEstimate = undefined;
            return cartService.getCountries().then(function (response) {
                $scope.countries = response.data.filter(function (x) {
                    return x.code2 != "US";
                });
                $scope.selectedCountry = $scope.countries[0];
                $scope.shippingMethods.showEstimateShippingModal = true;
            });
        };

        $scope.getCartShippingEstimate = function () {
            var address = {};
            $scope.gotEstimate = false;
            $scope.hasShippingErrors = false;
            $scope.invalidPostalCode = false;
            $scope.locationNotShipping = false;
            if ($scope.selectedDest == "US") {
                var zipCode = document.getElementById("zipCode").value;
                address.postalCode = zipCode;
                address.countryName = "United States";
                address.countryCode = "US";
                if (address.postalCode == "") {
                    $scope.hasShippingErrors = true;
                } else if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode)) {
                    $scope.invalidPostalCode = true;
                }
            } else {
                $scope.hasShippingErrors = false;
                address.countryName = $scope.selectedCountry.name;
                address.countryCode = $scope.selectedCountry.code2;
            }
            if (!$scope.hasShippingErrors && !$scope.invalidPostalCode) {
                if (
                    angular.isDefined($scope.isCouponApplied) &&
                    $scope.isCouponApplied
                ) {
                    address.CouponCode = $scope.isCouponApplied
                        ? $scope.couponCode
                        : "";
                }
                cartService
                    .getCartShippingEstimate(address)
                    .then(function (result) {
                        $scope.shippingEstimate = result.data.totalShipping;
                        $scope.vendorNotShipping =
                            result.data.vendorNotShipping;
                        $scope.invalidPostalCode =
                            result.data.invalidPostalCode;
                        $scope.locationNotShipping =
                            !!result.data.locationNotShipping;
                        if ($scope.locationNotShipping) {
                            $scope.shippingEstimate = 0.0;
                        }
                        $scope.gotEstimate = true;
                    });
            }
        };

        $scope.countryChange = function (selectedCountry) {
            $scope.selectedCountry = selectedCountry;
        };

        $scope.destChange = function () {
            if ($scope.selectedDest == "US") {
                $scope.selectedDest = "Intl";
                $scope.selectedCountry = $scope.countries[0];
            } else {
                $scope.selectedDest = "US";
            }
        };

        $scope.ChooseShippingMethod = function () {
            if ($scope.customer && $scope.customer.isRegisteredUser) {
                if (
                    $scope.customer.salutation &&
                    $scope.customer.salutation.toLowerCase() == "guest"
                ) {
                    $rootScope.toggleModal("showloginOptionsModal", true);
                } else {
                    if (!$scope.showUnavailablelbl) {
                        if ($scope.cartHasPhysicalProduct()) {
                            var physicalProducts = getPhysicalProducts(
                                $scope.cart.items
                            );
                            if (
                                angular.isDefined(physicalProducts) &&
                                physicalProducts.length > 0
                            ) {
                                var prdIds = _.pluck(
                                    physicalProducts,
                                    "productId"
                                );
                                commonService
                                    .getProductsInventory(prdIds)
                                    .then(function (response) {
                                        if (response) {
                                            checkProductsAvailability();
                                            if (!$scope.showUnavailablelbl) {
                                                $scope.CheckoutCart();
                                            } else {
                                                $scope.shippingMethods.showModal = true;
                                                $rootScope.appModalOpen = true;
                                            }
                                        }
                                    });
                            }
                        } else if ($scope.isCartHasOnlyGC()) {
                            $scope.CheckoutCart();
                        } else {
                            $scope.shippingMethods.showModal = true;
                            $rootScope.appModalOpen = true;
                        }
                    } else {
                        alert(
                            "There are item(s) in your shopping cart which are currently out of stock. If you wish to proceed for checkout, simply update the quantity or remove the out of stock item(s) form your cart."
                        );
                    }
                }
            } else {
                $rootScope.toggleModal("showloginOptionsModal", true);
            }
        };

        $scope.getPageContent = function () {
            membershipService.getPageContent().then(function (response) {
                if (response && response.data) {
                    $rootScope.benefits = response.data.cart.benefits;
                }
            });
        };

        //#endregion

        //#region Coupon Related Methods

        function hasCouponDiscount(cart, couponCode) {
            if (!cart || !couponCode) {
                return false;
            }

            var code = couponCode.toLowerCase();

            function discountMatches(discount) {
                return (
                    discount &&
                    discount.amount &&
                    discount.amount.amount > 0 &&
                    discount.coupon &&
                    discount.coupon.toLowerCase() === code
                );
            }

            if (cart.discounts && cart.discounts.some(discountMatches)) {
                return true;
            }

            if (!cart.items) {
                return false;
            }

            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                if (item.discounts && item.discounts.some(discountMatches)) {
                    return true;
                }
            }

            return false;
        }

        function isCouponEffectivelyApplied(cart) {
            if (!cart.coupons || cart.coupons.length === 0) {
                return false;
            }

            var coupon = cart.coupons[0];
            if (!coupon.code || !coupon.appliedSuccessfully) {
                return false;
            }

            if (hasCouponDiscount(cart, coupon.code)) {
                return true;
            }

            return cart.discountTotal && cart.discountTotal.amount > 0;
        }

        function clearCouponAppliedState() {
            $scope.appliedCoupon = null;
            $scope.couponValid = false;
            $scope.coupon = null;
            $scope.applyCoupon = false;
            $scope.removeCoupon();
        }

        function syncCouponStateFromCart(cart) {
            if (isCouponEffectivelyApplied(cart)) {
                $scope.applyCoupon = true;
                $scope.appliedCoupon = cart.coupons[0].code;
                $scope.couponValid = true;
                return;
            }

            clearCouponAppliedState();
        }

        $scope.removeCoupon = function () {
            localStorage.removeItem("IsCouponApplied");
            localStorage.removeItem("AppliedCoupon");
        };

        $scope.onCouponRemove = function (couponCode) {
            $rootScope.showLoader = true;
            cartService
                .removeCoupon(couponCode)
                .then(function (response) {
                    $rootScope.showLoader = false;
                    // Clear the applied coupon state immediately
                    $scope.appliedCoupon = null;
                    $scope.couponValid = false;
                    $scope.coupon = null;
                    $scope.applyCoupon = false;

                    // Remove from localStorage
                    $scope.removeCoupon();

                    // Refresh cart to update totals
                    getCart();
                    $rootScope.$broadcast("CustomerCartChanged");
                })
                .catch(function (error) {
                    $rootScope.showLoader = false;
                });
        };

        $scope.onCouponApply = function (couponCode) {
            $scope.couponErrorMessage = "";
            try {
                if (couponCode.length > 0) {
                    $rootScope.showLoader = true;
                    var coupon = {
                        Code: "",
                        Description: "",
                        AppliedSuccessfully: false,
                        ErrorCode: "",
                    };
                    coupon.Code = couponCode;
                    $scope.cart.coupons = coupon;
                    return cartService
                        .validateCoupon($scope.cart.coupons)
                        .then(function (result) {
                            $rootScope.showLoader = false;
                            $scope.appliedCoupon = couponCode;
                            $scope.couponValid =
                                result.data.appliedSuccessfully;
                            if (result.data.errorCode == "") {
                                $scope.couponErrorMessage =
                                    "Invalid coupon code.";
                            } else if (
                                result.data.errorCode.toLowerCase() ==
                                "usageexceeded"
                            ) {
                                $scope.couponErrorMessage =
                                    "Coupon already redeemed.";
                            } else if (
                                result.data.errorCode.toLowerCase() ==
                                "restrictedcoupon"
                            ) {
                                $scope.couponErrorMessage =
                                    "Login to enjoy this coupon.";
                            } else if (
                                result.data.errorCode.toLowerCase() ==
                                "salepricegreater"
                            ) {
                                $scope.couponErrorMessage =
                                    "Higher discount already applied in your cart.";
                            }
                            if ($scope.couponValid) {
                                localStorage.setItem("IsCouponApplied", true);
                                localStorage.setItem(
                                    "AppliedCoupon",
                                    $scope.appliedCoupon
                                );
                                cartService
                                    .addCoupon(result.data.code)
                                    .then(function () {
                                        getCart();
                                    });
                            }
                        });
                } else {
                    $scope.couponValid = false;
                }
            } catch (err) {
                $rootScope.showLoader = false;
            }
        };

        $scope.toggleCouponSection = function (state) {
            $scope.coupon = null;
            $scope.couponValid = null;
            $scope.applyCoupon = state;
        };

        $scope.onCouponKeyPress = function (event) {
            if (event && event.which === 13) {
                $scope.onCouponApply(event.target.value);
            }
        };
        //#endregion

        //#region Instant Lettering Related
        $scope.updateILDownloadFormat = function (itemId, reqId) {
            var e = document.getElementById("formats");
            var ilItem = {
                ItemId: itemId,
                RequestId: reqId,
                UpdatedDownloadFormat: e.value,
            };
            cartService
                .updateInstantLetteringDownloadFormat(ilItem)
                .then(function (response) {});
        };
        //#endregion

        //#region Embrilliance cart section (display only when cart has Embrilliance products)
        $scope.embrillianceCartFontPacks = [];
        $scope.embrillianceCartBundles = [];
        $scope.embrillianceRecommendationsLoaded = false;

        function cartItemToHit(item) {
            var id = (item.productId || item.id || "").toString();
            return {
                _id: id,
                _source: {
                    itemId: id,
                    name: item.name || "",
                    catalog: item.catalogId || "",
                    listPrice: item.listPrice && item.listPrice.amount != null ? item.listPrice.amount : (item.listPrice || 0),
                    salePrice: (item.salePrice && item.salePrice.amount != null ? item.salePrice.amount : null) || (item.listPrice && item.listPrice.amount != null ? item.listPrice.amount : null),
                    clubPrice: (item.clubPrice && item.clubPrice.amount != null ? item.clubPrice.amount : null) || 0,
                    variants: item.variants || [],
                    definitionName: item.definitionName || "",
                    rating: item.rating != null ? item.rating : 0,
                    saleRank: item.saleRank != null ? item.saleRank : 0,
                    videoParts: item.videoParts,
                    runTime: item.runTime
                }
            };
        }

        function fillEmbrillianceFromCart() {
            var items = ($scope.cart && $scope.cart.items) ? $scope.cart.items : [];
            var fontIds = {};
            var bundleIds = {};
            $scope.embrillianceCartFontPacks.forEach(function (h) {
                var id = (h._source && h._source.itemId || "").toString().toLowerCase();
                if (id) fontIds[id] = true;
            });
            $scope.embrillianceCartBundles.forEach(function (h) {
                var id = (h._source && h._source.itemId || "").toString().toLowerCase();
                if (id) bundleIds[id] = true;
            });
            items.forEach(function (item) {
                var def = (item.definitionName || "").toLowerCase();
                var id = (item.productId || item.id || "").toString().toLowerCase();
                if (!id) return;
                if (def === "fontpack" && $scope.embrillianceCartFontPacks.length < 3 && !fontIds[id]) {
                    $scope.embrillianceCartFontPacks.push(cartItemToHit(item));
                    fontIds[id] = true;
                } else if ((def === "designpack" || def === "projectpack") && $scope.embrillianceCartBundles.length < 3 && !bundleIds[id]) {
                    $scope.embrillianceCartBundles.push(cartItemToHit(item));
                    bundleIds[id] = true;
                }
            });
        }

        function applyEmbrillianceCartSplit(list) {
            var arr = list || [];
            var fonts = [];
            var bundles = [];
            arr.forEach(function (h) {
                var def = (h._source && h._source.definitionName ? h._source.definitionName : "").toLowerCase();
                if (def === "fontpack" && fonts.length < 2) fonts.push(h);
                else if ((def === "designpack" || def === "projectpack") && bundles.length < 2) bundles.push(h);
            });
            $scope.embrillianceCartFontPacks = fonts;
            $scope.embrillianceCartBundles = bundles;
        }

        function fillEmbrillianceFontAndBundleRecommendations(combinedList, cartProductIds) {
            var existingFromCart = $scope.embrillianceCartFontPacks.concat($scope.embrillianceCartBundles);
            var merged = (existingFromCart || []).concat(combinedList || []);
            applyEmbrillianceCartSplit(merged);
            var needFonts = Math.max(0, 2 - $scope.embrillianceCartFontPacks.length);
            var needBundles = Math.max(0, 2 - $scope.embrillianceCartBundles.length);
            var existingIds = {};
            $scope.embrillianceCartFontPacks.concat($scope.embrillianceCartBundles).forEach(function (h) {
                var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                if (id) existingIds[id] = true;
            });
            if (cartProductIds && cartProductIds.length) {
                cartProductIds.forEach(function (id) {
                    var key = (id || "").toString().toLowerCase();
                    if (key) existingIds[key] = true;
                });
            }
            var promise = $q.when();
            if (needFonts > 0) {
                promise = promise.then(function () {
                    return commonService
                        .getElasticData(
                            configs.elasticBaseUrl,
                            embrillianceElasticService.buildStarterPacksRequest(10, ["FontPack"])
                        )
                        .then(function (res) {
                            var hits =
                                res && res.data && res.data.hits && res.data.hits.hits
                                    ? res.data.hits.hits
                                    : [];
                            for (var i = 0; i < hits.length && $scope.embrillianceCartFontPacks.length < 2; i++) {
                                var h = hits[i];
                                var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                                if (id && !existingIds[id]) {
                                    $scope.embrillianceCartFontPacks.push(h);
                                    existingIds[id] = true;
                                }
                            }
                        });
                });
            }
            if (needBundles > 0) {
                promise = promise.then(function () {
                    return commonService
                        .getElasticData(
                            configs.elasticBaseUrl,
                            embrillianceElasticService.buildStarterPacksRequest(10, [
                                "DesignPack",
                                "ProjectPack",
                            ])
                        )
                        .then(function (res) {
                            var hits =
                                res && res.data && res.data.hits && res.data.hits.hits
                                    ? res.data.hits.hits
                                    : [];
                            for (var i = 0; i < hits.length && $scope.embrillianceCartBundles.length < 2; i++) {
                                var h = hits[i];
                                var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                                if (id && !existingIds[id]) {
                                    $scope.embrillianceCartBundles.push(h);
                                    existingIds[id] = true;
                                }
                            }
                        });
                });
            }
            return promise;
        }

        // Show Embrilliance recommendations only when cart contains at least one item
        // with catalogId "BriTon Leap" and definitionName "Software".
        $scope.cartHasEmbrillianceProduct = function () {
            if (
                angular.isDefined($scope.cart) &&
                angular.isDefined($scope.cart.items) &&
                $scope.cart.items.length > 0
            ) {
                return $scope.cart.items.some(function (item) {
                    var catalog = (item.catalogId || "").trim().toLowerCase();
                    var definitionName = (item.definitionName || "").trim().toLowerCase();
                    return catalog === "briton leap" && definitionName === "software";
                });
            }
            return false;
        };

        function loadEmbrillianceCartRecommendations() {
            $scope.embrillianceRecommendationsLoaded = false;
            var cartProductIds = [];
            if ($scope.cart && $scope.cart.items && $scope.cart.items.length) {
                $scope.cart.items.forEach(function (item) {
                    var id = (item.productId || item.id || "").toString().toLowerCase();
                    if (id) cartProductIds.push(id);
                });
            }
            var embrillianceCartProductIds =
                window.__env &&
                window.__env.embrillianceCartProductIds &&
                window.__env.embrillianceCartProductIds.length
                    ? window.__env.embrillianceCartProductIds
                    : [];
            var targetCount = 6;

            function filterOutCartIds(hits) {
                if (!cartProductIds.length) return hits || [];
                var set = {};
                cartProductIds.forEach(function (id) { set[id] = true; });
                var filtered = (hits || []).filter(function (h) {
                    var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                    return !id || !set[id];
                });
                return filtered;
            }

            function setFallbackRecommendations() {
                return commonService
                    .getElasticData(
                        configs.elasticBaseUrl,
                        embrillianceElasticService.buildStarterPacksRequest(targetCount, [
                            "ProjectPack",
                            "FontPack",
                            "DesignPack",
                        ])
                    )
                    .then(function (fallbackResponse) {
                        var raw = (fallbackResponse && fallbackResponse.data && fallbackResponse.data.hits && fallbackResponse.data.hits.hits)
                            ? fallbackResponse.data.hits.hits.slice(0, targetCount)
                            : [];
                        return fillEmbrillianceFontAndBundleRecommendations(filterOutCartIds(raw), cartProductIds);
                    })
                    .then(function () { fillEmbrillianceFromCart(); })
                    .finally(function () { $scope.embrillianceRecommendationsLoaded = true; });
            }

            if (embrillianceCartProductIds.length === 0) {
                setFallbackRecommendations();
                return;
            }

            commonService
                .getElasticData(
                    configs.elasticBaseUrl,
                    embrillianceElasticService.buildProductByIdsRequest(angular.toJson(embrillianceCartProductIds))
                )
                .then(function (response) {
                    var hits =
                        response &&
                        response.data &&
                        response.data.hits &&
                        response.data.hits.hits
                            ? response.data.hits.hits
                            : [];

                    var idToHit = {};
                    hits.forEach(function (h) {
                        var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                        if (id) idToHit[id] = h;
                    });
                    var ordered = [];
                    embrillianceCartProductIds.forEach(function (id) {
                        var key = id.toLowerCase();
                        if (idToHit[key]) ordered.push(idToHit[key]);
                    });
                    ordered = filterOutCartIds(ordered);
                    var needCount = targetCount - ordered.length;
                    if (needCount <= 0) {
                        return fillEmbrillianceFontAndBundleRecommendations(ordered.slice(0, targetCount), cartProductIds)
                            .then(function () { fillEmbrillianceFromCart(); })
                            .finally(function () { $scope.embrillianceRecommendationsLoaded = true; });
                    }

                    var existingIds = {};
                    ordered.forEach(function (h) {
                        var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                        if (id) existingIds[id] = true;
                    });
                    var cartIdSet = {};
                    cartProductIds.forEach(function (id) {
                        var key = (id || "").toString().toLowerCase();
                        if (key) cartIdSet[key] = true;
                    });

                    commonService
                        .getElasticData(
                            configs.elasticBaseUrl,
                            embrillianceElasticService.buildStarterPacksRequest(targetCount + needCount, [
                                "ProjectPack",
                                "FontPack",
                                "DesignPack",
                            ])
                        )
                        .then(function (fallbackResponse) {
                            var fallbackHits =
                                fallbackResponse &&
                                fallbackResponse.data &&
                                fallbackResponse.data.hits &&
                                fallbackResponse.data.hits.hits
                                    ? fallbackResponse.data.hits.hits
                                    : [];
                            var filler = [];
                            for (var i = 0; i < fallbackHits.length && filler.length < needCount; i++) {
                                var h = fallbackHits[i];
                                var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                                if (id && !existingIds[id] && !cartIdSet[id]) {
                                    filler.push(h);
                                    if (id) existingIds[id] = true;
                                }
                            }
                            return fillEmbrillianceFontAndBundleRecommendations(
                                ordered.concat(filler).slice(0, targetCount),
                                cartProductIds
                            );
                        })
                        .then(function () { fillEmbrillianceFromCart(); })
                        .finally(function () { $scope.embrillianceRecommendationsLoaded = true; });
                });
        }
        //#endregion

        //#region Guest Checkout Related
        $scope.validateEmails = function () {
            $scope.validationMessage = "";
            $scope.isValidForm = true;
            $scope.txtEmail = document.getElementById("txtEmaile").value;
            $scope.txtConfirmEmail =
                document.getElementById("txtConfirmEmaile").value;
            if (!$scope.txtEmail || !$scope.txtConfirmEmail) {
                $scope.validationMessage =
                    "Both email fields are required and must match.";
                $scope.isValidForm = false;
                return;
            }

            var emailPattern = $scope.regularExpressions;
            if (!emailPattern.test($scope.txtEmail)) {
                $scope.validationMessage =
                    "Please enter a valid email address.";
                $scope.isValidForm = false;
                return;
            }

            if (
                $scope.txtEmail.toLowerCase() !=
                $scope.txtConfirmEmail.toLowerCase()
            ) {
                $scope.validationMessage =
                    "Email addresses do not match. Please try again.";
                $scope.isValidForm = false;
                return;
            }
        };

        $scope.proceedToGuestCheckout = function () {
            $rootScope.showLoader = true;
            $scope.validateEmails();
            if (!$scope.isValidForm) {
                $rootScope.showLoader = false;
                return;
            } else {
                cartService
                    .guestCheckoutAccess(
                        document.getElementById("txtEmaile").value
                    )
                    .then(
                        function (response) {
                            if (response.data.toLowerCase() == 'true') {
                                $window.location.href =
                                    "/cart/checkout/shipping";
                            }
                            else if(response.data.toLowerCase() == 'userexists'){
                                $scope.validationMessage =
                                    "This email address is already registered. Please login to your account to continue with checkout.";
                                    $scope.isValidForm = false;
                                    $rootScope.showLoader = false;
                            }
                             else {
                                $scope.validationMessage =
                                    "Guest checkout is not available. Please create an account to proceed with checkout.";
                                $scope.isValidForm = false;
                                $rootScope.showLoader = false;
                            }
                        },
                        function (error) {
                            $scope.validationMessage =
                                "Error processing request. Please try again.";
                            $scope.isValidForm = false;
                            $rootScope.showLoader = false;
                        }
                    );
            }
        };
        $scope.closeAndRedirectToLogin = function () {
            $rootScope.toggleModal("showloginOptionsModal", false);
            $window.location.href = "/account/login";
        };
        $scope.proceedToShowGuestCheckout = function () {
            $scope.showGuestCheckout = true;
        };
        //#endregion
    },
]);

storefrontApp.controller("recentlyAddedCartItemDialogController", [
    "$scope",
    "$window",
    "$uibModalInstance",
    "dialogData",
    function ($scope, $window, $uibModalInstance, dialogData) {
        $scope.$on("CustomerCartChanged", function (event, data) {
            dialogData.updated = true;
        });

        $scope.dialogData = dialogData;

        $scope.close = function () {
            $uibModalInstance.close();
        };

        $scope.redirect = function (url) {
            $window.location = url;
        };
    },
]);
